module.exports = __webpack_public_path__ + "img/time.324ef4ab.svg";